import Container from './DeviationFormPopup.container';
import DeviationFormPopup from './DeviationFormPopup';

export default Container(DeviationFormPopup);
